import React, { useEffect, useState } from "react";
import EditModal from "./shared/EditModal";
import { MdEdit, MdDelete} from "react-icons/md";
import { FaFileAlt } from "react-icons/fa";

export default function CertificationsSection({ value = [], onChange }) {
  const [items, setItems] = useState(value || []);
  const [open, setOpen] = useState(false);
  const [editIdx, setEditIdx] = useState(null);

  useEffect(() => setItems(value || []), [value]);

  // --- Updated fields ---
  const fields = [
    { name: "name", label: "Domain Name", type: "text", placeholder: "Which domain you have the certification" },
    { name: "provider", label: "Certificate Provider", type: "text", placeholder: "Who issued the certificate" },
    { name: "url", label: "Certificate URL", type: "text", placeholder: "Optional link to view certificate" },
    { name: "start", label: "Start Date", type: "text", placeholder: "YYYY-MM" },
    { name: "end", label: "End Date", type: "text", placeholder: "YYYY-MM" },
    { name: "file", label: "Upload Certificate", type: "file", accept: ".pdf,image/*", hint: "Upload PDF or image file" },
  ];

  const openAdd = () => { setEditIdx(null); setOpen(true); };
  const openEdit = (i) => { setEditIdx(i); setOpen(true); };

  const save = (obj) => {
    const next = [...items];
    if (editIdx == null) next.push(obj);
    else next[editIdx] = obj;
    setItems(next);
    onChange(next);
  };

  const remove = (i) => {
    const next = items.filter((_, idx) => idx !== i);
    setItems(next);
    onChange(next);
  };

  return (
    <section className="ccard">
      <div className="card-head">
        <h3>Certifications & Achievements</h3>
        <div className="card-actions">
          <button className="link" onClick={openAdd}>Add</button>
        </div>
      </div>

      <div className="card-body">
        {items.length === 0 ? (
          <p className="muted">No certifications</p>
        ) : (
          items.map((c, i) => (
            <div className="item-row" key={i}>
              <div>
                <div className="item-title">{c.name}</div>
                <div className="muted">
                  {c.provider && <div className="cprovider"><strong>Provider:</strong> {c.provider}</div>}
                  {c.start && c.end && <div className="cstart">{c.start} — {c.end}</div>}
                  {c.url && (
                    <div className="clink">
                      <a href={c.url} target="_blank" rel="noreferrer">
                        {c.url}
                      </a>
                    </div>
                  )}
                  {c.fileName && (
                    <div className="cfile">
                      <FaFileAlt className="fic"/>
                      {c.file instanceof Blob ? (
                      <a href={URL.createObjectURL(c.file)} target="_blank" rel="noreferrer" style={{color: "#2563eb"}}>
                        {c.fileName}
                      </a>): (
                       <span>{c.fileName}</span>)}
                    </div>
                  )}
                </div>
              </div>

              <div className="item-actions">
                <MdEdit title="Edit" className="smalll" onClick={() => openEdit(i)} />
                <MdDelete title="Delete" className="smalll danger" onClick={() => remove(i)} />
              </div>
            </div>
          ))
        )}
      </div>

      {open && (
        <EditModal
          title={editIdx == null ? "Add Certification" : "Edit Certification"}
          initial={editIdx == null ? {} : items[editIdx]}
          fields={fields}
          onClose={() => setOpen(false)}
          onSave={(d) => {
            if (d.file && d.file.name) d.fileName = d.file.name;
            save(d);
            setOpen(false);
          }}
        />
      )}
    </section>
  );
}
